<template>
  <div class="quickly" v-loading="loading">
    <div class="index-header">
      <span class="title">
        <svg-icon icon-class="quickIco" class="iconTitle"></svg-icon>快捷入口
      </span>
      <span class="other more" @click="showMore" v-if="dataico.length > 9">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>
    <div class="container">
      <template v-for="(item, index) in dataico">
        <div
          v-if="index < 9"
          :key="index"
          class="ico"
          @click="linkTo(item.router, item.link)"
          style="margin-bottom: 5px"
        >
          <div class="container-card">
            <svg-icon
              :icon-class="item.icoClassName"
              class="iconstyle"
            ></svg-icon>
            <div
              class="container-card-text"
              v-if="item.titleName === '微信决策管理'"
              style="color: red"
            >
              {{ item.titleName }}
            </div>
            <div class="container-card-text" v-else>{{ item.titleName }}</div>
          </div>
          <!-- <div class="container-card">{{item.titleName}}</div> -->
        </div>
      </template>
    </div>
    <!-- 更多弹窗 -->
    <div class="menuSearchBox" :class="{ menuSearchBoxShow: isShowMenuSearch }">
      <div class="header">
        <div class="menu-search"></div>
        <span class="close" @click="closeMenuSearch">
          <svg-icon icon-class="close" />
        </span>
      </div>
      <!-- 图标 -->
      <div class="menu-body ub">
        <template v-for="(childitem, childidx) in dataico">
          <div
            :key="childidx"
            class="ico"
            @click="linkTo(childitem.router, childitem.link)"
          >
            <div class="container-card">
              <svg-icon
                :icon-class="childitem.icoClassName"
                class="iconstyle"
              ></svg-icon>
              <div class="container-card-text">{{ childitem.titleName }}</div>
            </div>
          </div>
        </template>
      </div>

      <!-- <div class="menu-box-container">
        <div class="module" v-for="(item,index) in router" :key="index">
          <div class="module-title">{{item.name}}</div>
          <ul>
            <template v-for="(childItem ,childIndex) in item.children">
              <li v-if="childItem.meta.isShowMenu" :key="childIndex" @click="linkTo(childItem.path, childItem.link)">{{childItem.name}}</li>
            </template>
          </ul>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import { HomePageControllerSvr } from '@/service/HomePageControllerSvr/HomePageControllerSvr';
import { mapState } from 'vuex';
import { identityEnum } from '@/enum/identityEnum';
import { SysConfigServiceSvr } from '@/service/SysConfigMge/SysConfigServiceSvr';
export default {
  components: {},
  props: {},
  data() {
    return {
      OrgCode: '',
      EaAreaCode: '',
      loading: false,
      status: '',
      tempNum: 0,
      router: [],
      isShowMenuSearch: false,
      identityEnum: new identityEnum(),
      dataico: [],
      code: localStorage.getItem('code'),

      // 更多功能配置
      dataico2: [
        {
          typeNmae: '机构查询',
          children: [
            {
              icoClassName: 'organizationalMage',
              titleName: '机构查询',
              router: '/queryOrganMge',
              right: ['业务领导', '物业市局工作人员', '物业区局工作人员'],
            },
            {
              icoClassName: 'InstitutionalPersonnelMge',
              titleName: '机构用户管理',
              router: '/InstitutionUserManageList',
              right: ['业务领导', '系统管理员', '企业人员'],
            },
          ],
          right: [
            '业务领导',
            '系统管理员',
            '企业人员',
            '物业市局工作人员',
            '物业区局工作人员',
          ],
        },
        {
          typeNmae: '安全生产',
          children: [
            // {
            //   icoClassName: 'HonestyDeclaration',
            //   titleName: '安全生产检查管理',
            //   router: 'SafeProductionCheckList',
            //   right: [
            //     '街道办',
            //     '业委会',
            //     '物业区领导',
            //     '系统管理员',
            //     '物业市局工作人员',
            //     '物业区局工作人员'
            //   ]
            // },
            {
              icoClassName: 'BusinessWillRecord',
              titleName: '安全生产检查库',
              router: 'safetyDetailsList',
              right: [
                '街道办',
                '物业市局工作人员',
                '物业区局工作人员',
                '物业区领导',
                '系统管理员',
              ],
            },
            {
              icoClassName: 'HonestyDeclaration',
              titleName: '发起安全检查',
              router: 'SafeProductionProcess',
              right: [
                '物业区领导',
                '物业市局工作人员',
                '物业区局工作人员',
                '系统管理员',
              ],
            },
            {
              icoClassName: 'newlyIncreased',
              titleName: '发起专项检查',
              router: 'SpecialInspectionProcess',
              right: [
                '物业区领导',
                '物业市局工作人员',
                '物业区局工作人员',
                '系统管理员',
              ],
            },
          ],
          right: [
            '街道办',
            '业委会',
            '物业区领导',
            '系统管理员',
            '物业市局工作人员',
            '物业区局工作人员',
            '项目经理',
          ],
        },
        {
          typeNmae: '物业企业管理',
          children: [
            //   {
            //   icoClassName: 'UndertakeFiling',
            //   titleName: '承接查验备案',
            //   router: '/undertakeInspectionRecord',
            //   right: ['日常管理员', '开发商', '系统管理员']
            // },
            {
              icoClassName: 'HonestyDeclaration',
              titleName: '诚信登记',
              router: '/integrityRegWork',
              right: [
                '街道办',
                '系统管理员',
                '业务领导',
                '物业区域领导',
                '物业市局领导',
              ],
            },
            {
              icoClassName: 'HonestyDeclaration',
              titleName: '诚信异议申请',
              router: '/integrityRegAgainstWork',
              right: [
                '街道办',
                '系统管理员',
                '业务领导',
                '物业区域领导',
                '物业市局领导',
              ],
            },
            {
              icoClassName: 'EnterprisePersonnelManagement',
              titleName: '企业人员管理',
              router: '/propertyManagementPersonnelList',
              right: ['系统管理员'],
            },
            {
              icoClassName: 'HonestRegistration',
              titleName: '良好行为诚信申报',
              router: '/goodBehaviorRegAddwork',
              right: ['项目经理'],
            },
            {
              icoClassName: 'HonestyReport',
              titleName: '诚信报表',
              router: '/intRegList',
              right: ['业务领导', '物业区领导', '系统管理员'],
            },
          ],
          right: ['日常管理员', '开发商', '企业人员', '街道办', '系统管理员'],
        },
        {
          typeNmae: '满意度调查',
          children: [
            {
              icoClassName: 'LaunchSatisfactionSurvey',
              titleName: '发起满意度调查',
              router: '/addMge',
              right: ['街道办', '系统管理员'],
            },
          ],
          right: ['街道办', '系统管理员'],
        },
        {
          typeNmae: '物业区域查询',
          children: [
            {
              icoClassName: 'EnterprisePersonManage',
              titleName: '房屋管理',
              router: '/housManage',
              right: ['开发商', '系统管理员', '业务领导'],
            },
            {
              icoClassName: 'BuildingMage',
              titleName: '楼栋管理',
              router: '/buildingList',
              right: ['系统管理员', '业务领导'],
            },
            {
              icoClassName: 'PropertyRegionalMage',
              titleName: '物业区域查询',
              router: '/queryPropertyArea',
              right: [
                '系统管理员',
                '业务领导',
                '物业市局工作人员',
                '物业区局工作人员',
              ],
            },
            // {
            //   icoClassName: 'HousingSupplement',
            //   titleName: '房屋补充',
            //   // router: '/eaHouseReg',//暂时关闭
            //   router: '',
            //   right: ['日常管理员', '系统管理员']
            // },
            // {
            //   icoClassName: 'HouseChange',
            //   titleName: '房屋变更',
            //   // router: '/houseChange',//暂时关闭
            //   router: '',
            //   right: ['日常管理员', '系统管理员']
            // }
          ],
          right: [
            '日常管理员',
            '系统管理员',
            '开发商',
            '业务领导',
            '物业市局工作人员',
            '物业区局工作人员',
          ],
        },
        {
          typeNmae: '设施设备',
          children: [
            {
              icoClassName: 'newlyIncreased',
              titleName: '新增维保',
              router: '/addMaintenance',
              right: ['工程人员', '日常管理员', '系统管理员'],
            },
            {
              icoClassName: 'WarrantyRegistration',
              titleName: '报修登记',
              router: '/addRepair',
              right: ['日常管理员', '系统管理员'],
            },
          ],
          right: ['工程人员', '日常管理员', '系统管理员'],
        },
        {
          typeNmae: '备案管理',
          children: [
            {
              icoClassName: 'BusinessWillRecord',
              titleName: '业委会备案',
              router: '/hashaOwnerCommitteeRecord',
              right: ['业委会', '系统管理员'],
            },
            // {
            //   icoClassName: 'minutesMeeting',
            //   titleName: '会议记录',
            //   router: '/conferenceRecordList',
            //   right: ['业委会', '系统管理员']
            // },
            {
              icoClassName: 'MemberMaintenance',
              titleName: '成员信息维护',
              router: '/memberMaintain',
              right: ['业委会', '系统管理员'],
            },
          ],
          right: ['业委会', '系统管理员'],
        },
        {
          typeNmae: '投诉管理',
          children: [
            {
              icoClassName: 'ComplaintRegistration',
              titleName: '投诉登记',
              router: '/registration',
              right: ['街道办', '日常管理员', '系统管理员'],
            },
            // {
            //   icoClassName: 'PeriodicReportComplaints',
            //   titleName: '投诉定期报告',
            //   router: '/periodicReports',
            //   right: ['物业区领导', '物业市局领导', '系统管理员']
            // }
          ],
          right: ['日常管理员', '街道办', '物业区领导', '系统管理员'],
        },
        {
          typeNmae: '检查考评',
          children: [
            {
              icoClassName: 'InitiateEvaluation',
              titleName: '发起考评',
              router: '/addCheckAndReview',
              right: ['街道办', '系统管理员'],
            },
          ],
          right: ['街道办', '系统管理员'],
        },
        // {
        //   //暂时关闭
        //   typeNmae: '业务单审批',
        //   children: [
        //     {
        //       icoClassName: 'EnterpriseInfoRecord',
        //       titleName: '企业信息备案',
        //       router: '/fakerrealtyMgeComBaseRecord',
        //       right: ['企业人员', '开发商', '系统管理员']
        //     }
        //   ],
        //   right: ['企业人员', '开发商', '系统管理员']
        // },
        // {
        //   typeNmae: '业委会自管',
        //   children: [],
        //   right: []
        // },
        // {
        //   typeNmae: '系统管理',
        //   children: [],
        //   right: []
        // },
        // {
        //   typeNmae: '业务单详情',
        //   children: [],
        //   right: []
        // },
        {
          typeNmae: '物业管理',
          children: [
            {
              icoClassName: 'PropertyContractFiling',
              titleName: '物业合同备案',
              router: '/propertyasdafa',
              right: ['日常管理员', '系统管理员'],
            },
          ],
          right: ['日常管理员', '开发商', '系统管理员'],
        },
        {
          typeNmae: '公告',
          children: [
            {
              icoClassName: 'AnnouncementIssue',
              titleName: '公告管理',
              router: 'noticeMore',
              right: ['街道办', '业委会', '物业区领导', '系统管理员'],
            },
          ],
          right: ['街道办', '业委会', '物业区领导', '系统管理员'],
        },
        {
          typeNmae: '企业信息上报',
          children: [
            {
              icoClassName: 'InformationMaintenancePropertyEnterprises',
              titleName: '物业企业信息维护',
              router: '/InformationMaintenanceReport',
              right: ['企业人员', '系统管理员'],
            },
            {
              icoClassName: 'ProjectInformationMaintenance',
              titleName: '物业项目信息维护',
              router: '/PropertyInformation',
              right: ['企业人员', '物业市局工作人员'],
            },
            {
              icoClassName: 'InformationMaintenanceConstructionUnits',
              titleName: '建设单位信息维护',
              router: '/ConstructionUnitInformationMaintenance',
              right: ['物业市局工作人员'],
            },
            {
              icoClassName: 'InformationMaintenanceOwnersCommittee',
              titleName: '业主委员会信息维护',
              router: '/ownersInfoMaintain',
              right: ['物业市局工作人员'],
            },
          ],
          right: ['项目经理', '企业人员', '物业市局工作人员'],
        },
        {
          typeNmae: '企业报表管理',
          children: [
            {
              icoClassName: 'report',
              titleName: '制定报表阶段',
              router: '/formulateReport',
              right: ['物业市局工作人员'],
            },
            {
              icoClassName: 'report',
              titleName: '物业申报解锁',
              router: '/propertyDeclareAdd',
              right: ['物业市局工作人员'],
            },
            // {
            //   icoClassName: 'report',
            //   titleName: '物业企业信息申报',
            //   router: '/propertyDeclare',
            //   right: ['企业人员']
            // }
          ],
          right: ['物业市局工作人员', '企业人员'],
        },
        // {
        //   typeNmae: '其他',
        //   children: [
        //     {
        //       icoClassName: 'OrdinaryUse',
        //       titleName: '普通使用',
        //       router: '',
        //       right: ['日常管理员', '系统管理员']
        //     }
        //   ],
        //   right: ['日常管理员', '系统管理员']
        // }
        // 子项
      ],
    };
  },
  computed: {
    ...mapState(['userInfo', 'addRouters', 'token', 'tabsRouter']),
  },
  created() {
    this.homePageControllerSvr = new HomePageControllerSvr();
    this.sysConfigServiceSvr = new SysConfigServiceSvr();
  },
  mounted() {
    this.loading = true;
    this.userTypeShow();
    this.sysConfigServiceSvr
      .getUserMenus(this.token)
      .then((res) => {
        let data2 = [];
        // this.dataico = res.quickly;
        if (res && res.quickly) {
          this.dataico = res.quickly.filter((item) => {
            return item.IsQuery == null || item.IsQuery == undefined;
          });
          this.dataico.forEach((item) => {
            if (item.titleName == '企业备用信息查询') {
              item.titleName = '企业在管项目';
              item.router = 'enterpriseManageProjectAudit';
            }
            if (item.titleName == '微信决策管理') {
              this.dataico = res.quickly.filter((item) => {
                return item.titleName !== '微信决策管理';
              });
            }
          });
          if (
            this.userInfo.DeptType != '专家' &&
            this.userInfo.DeptType != '开发建设单位'
          ) {
            this.dataico.unshift({
              icoClassName: 'PropertyRegionalMage',
              router: 'toWxjcgl',
              titleName: '微信决策管理',
            });
          }
        }

        this.loading = false;
      })
      .catch((err) => {
        this.$message({
          type: 'error',
          message: err.Msg,
        });
      });

    this.router = this.addRouters[0].children.filter((item) => {
      return item.children.some((_item) => {
        return _item.meta.isShowMenu;
      });
    });
    //获取所在小区编码
    this.homePageControllerSvr
      .GetAreaInfo(this.token, 0, 1)
      .then((res) => {
        if (res._Items.length != 0) {
          this.EaAreaCode = res._Items[0].EaAreaCode;
        }
      })
      .catch((err) => {
        this.$message({
          type: 'error',
          message: err.Msg,
        });
      });
    //获取orgCode
    this.OrgCode = this.userInfo.UserParam.OrgCode;
  },
  methods: {
    userTypeShow() {
      this.status = this.userInfo.UserParam.UserSigns
        ? this.identityEnum[this.userInfo.UserParam.UserSigns.split(',')[0]]
        : '';
    },
    showMore() {
      this.isShowMenuSearch = !this.isShowMenuSearch;
    },
    closeMenuSearch() {
      this.isShowMenuSearch = false;
    },
    linkTo(router, link) {
      if (!router && !link) {
        this.$message('该功能尚未开放');
        return;
      }
      console.log(123);
      if (link) {
        window.open(link, '_blank');
      } else {
        if (router === '/addRepair') {
          this.$router.push({
            path: router,
            query: { token: this.token, t: Date.now() },
          });
          return;
        }
        if (router === '/propertyAreaInfo') {
          this.$router.push({
            path: router,
            query: { EaAreaCode: this.EaAreaCode, t: Date.now() },
          });
          return;
        }
        if (router === '/propertyEnterpriseRegistrationInfo') {
          this.$router.push({
            path: router,
            query: { OrgCode: this.OrgCode, t: Date.now() },
          });
          return;
        }
        if (router === 'setEaAreaMap') {
          this.$router.push({
            path: router,
            query: { toolStatus: 4, t: Date.now() },
          });
          return;
        }
        let flag = true;
        for (let i = 0; i < this.tabsRouter.length; i++) {
          if (this.tabsRouter[i].path === router) {
            flag = false;
          }
        }
        if (!flag) {
          this.$router.push({
            path: router,
            query: {
              t: '',
            },
          });
        } else {
          this.$router.push({
            path: router,
            query: {
              t: Date.now(),
            },
          });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import './css/common.scss';
.quickly {
  width: 100%;
  background: #fff;
  position: relative;
  .index-header {
    .more {
      transition: all 0.3s;
      &:hover {
        color: #4a94df;
      }
    }
  }
  .iconTitle {
    font-size: 18px;
    margin: 0 6px;
    color: blue;
  }
  .iconstyle {
    font-size: 28px;
    margin: 0 6px;
    color: #ffb11a;
    margin-top: 10px;
  }
  .menu-body {
    .ico {
      flex-shrink: 0;
      width: 33.3%;
      .container-card {
        cursor: pointer;
        text-align: center;
        .container-card-text {
          margin-top: 10px;
        }
      }
    }
  }
  .container {
    // height: 140px;
    padding: 10px 10px 20px 0;
    max-height: 260px;
    min-height: 259px;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    .ico {
      width: 32%;
      height: 70px;
      margin-left: 3px;
      margin-top: 3px;
      display: flex;
      justify-content: center;
      cursor: pointer;
      .container-card {
        text-align: center;
        .container-card-text {
          margin-top: 10px;
        }
      }
    }
  }
  .menuSearchBox {
    background: #fff;
    width: 310px;
    // max-height: calc(100vh - 427px);
    max-height: calc(100vh - 167px);
    padding: 40px 20px;
    box-sizing: border-box;
    box-shadow: -2px 2px 8px 0 rgba(0, 0, 0, 0.2);
    position: absolute;
    z-index: 8;
    top: 35px;
    transform: translate3d(320px, 0, 0);
    transition: transform 0.5s;
    overflow-y: auto;
    .containers {
      // height: 140px;
      padding: 10px 0;
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;
      .ico {
        width: 32%;
        height: 70px;
        margin-left: 3px;
        margin-top: 3px;
        display: flex;
        justify-content: center;
        cursor: pointer;
        .container-card {
          text-align: center;
          cursor: pointer;
          .container-card-text {
            margin-top: 10px;
          }
        }
      }
    }
    .close {
      position: absolute;
      right: 15px;
      top: 15px;
      cursor: pointer;
    }
    .menu-search {
      .el-autocomplete {
        width: 80%;
      }
    }
    .menu-box-container {
      padding-top: 10px;
      column-count: 3;
      column-gap: 0;
      column-width: 200px;
      .module {
        break-inside: avoid;
        margin-right: 5%;
        margin-bottom: 20px;
        .module-title {
          margin: 5px 0 15px 0;
          font-size: 18px;
          font-weight: bold;
        }
        &:nth-child(3n) {
          margin-right: 0;
        }
        li {
          margin: 5px 0;
          font-size: 14px;
          color: #000;
          opacity: 0.65;
          line-height: 30px;
          cursor: pointer;
          &:hover {
            background: #f0f0f0;
          }
        }
      }
    }
  }
  .menuSearchBoxShow {
    transform: translate3d(0, 0, 0);
  }
}
</style>
